import { Buffer } from 'buffer'

export const enCodeBase64 = (code) => {
  return Buffer.from(code).toString('base64')
}
export const deCodeBase64 = (code) => {
  return Buffer.from(code, 'base64').toString('utf8')
}
